import axios from "../../../axios";

export const getAboutUs = () => {
  const response = axios.get(`cms/about-us-info/`);
  return response;
};

export const getFaq = () => {
  const response = axios.get(`cms/faqs/`);
  return response;
};

export const getShopData = () => {
  const response = axios.get(`/shops/list/`);
  return response;
};
